// 组件
import Table from './table'
import VxeTable from './vxe-table'
import DelButton from './del-button'
import PopDelButton from './pop-del-button'
import InputNumber from './input-number'
import Card from './card'
import Dialog from './dialog'
import Input from './input'
import Empty from './empty'
import DatePicker from './date-picker'
import TableColumnFormat from './table-column-format'
import DateRangePicker from './date-range-picker'
import MoreButton from './more-button'
import Slider from './slider'
import AIHistoryChat from './ai-history-chat'
import AIChatMain from './ai-chat-main'

// 所有组件列表
const components = [
  Table,
  VxeTable,
  DelButton,
  InputNumber,
  Card,
  Dialog,
  Input,
  Empty,
  DatePicker,
  TableColumnFormat,
  DateRangePicker,
  PopDelButton,
  MoreButton,
  Slider,
  AIHistoryChat,
  AIChatMain
]

// 定义 install 方法，接收 Vue 作为参数
const install = function (Vue) {
  // 判断是否安装，安装过就不继续往下执行
  if (install.installed) return
  install.installed = true
  // 遍历注册所有组件
  components.forEach(component => Vue.component(component.name, component))
}

// 检测到 Vue 才执行
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
// 导出组件
export default {
  ShUI: {
    install,
    // 所有组件，必须具有 install，才能使用 Vue.use()
    Table,
    VxeTable,
    DelButton,
    InputNumber,
    Card,
    Dialog,
    // Charts,
    Input,
    Empty,
    DatePicker,
    TableColumnFormat,
    DateRangePicker,
    PopDelButton,
    MoreButton,
    Slider,
    AIHistoryChat,
    AIChatMain
  }
}
export {
  Table,
  VxeTable,
  DelButton,
  InputNumber,
  Card,
  Dialog,
  Input,
  Empty,
  DatePicker,
  TableColumnFormat,
  DateRangePicker,
  PopDelButton,
  MoreButton,
  Slider,
  AIHistoryChat,
  AIChatMain
}
